define('flight-components/KeywordSearch',[
  'App',
  'flight/lib/component',
  'flight-components/mixins/withSearchSuggest',
  'URIjs/URI'
],

function(App, defineComponent, withSearchSuggest, URI) {

  var KeywordSearch = function KeywordSearch() {

    this.defaultAttrs({
      typeahead: true,
      formSelector: '[data-form="keyword-search"]',
      keywordInputSelector: 'input[name="keywords"]',
      errorMsgSelector: '.input-error-msg'
    });

    this.validateKeywords = function() {
      var keywords = this.select('keywordInputSelector').val();

      // keyword terms must be at least 2 letters
      if (keywords.length < 2) {
        this.showErrors('Must provide at least 2 characters');
        return false;
      }

      // keywords are valid - submit the query.
      // Must turn off submit listener first.
      this.select('formSelector')
        .off('submit')
        .submit();
    };

    this.hideErrors = function() {
      this.select('keywordInputSelector').removeClass('error');
      this.select('errorMsgSelector').hide();
    };

    this.showErrors = function(msg) {
      this.select('keywordInputSelector').addClass('error');
      this.select('errorMsgSelector').text(msg).show();
    }

    this.after('initialize', function() {

      var self = this;

      this.select('formSelector').on('submit', function(ev) {
        ev.preventDefault();
        self.validateKeywords();
      });

      this.select('keywordInputSelector').on('focus', function(){
        self.hideErrors();
      });

    });

  };

  return defineComponent(KeywordSearch, withSearchSuggest);

});

